
import React from 'react';
import { Document, Page, Text, View, StyleSheet, Image,Font, pdf  } from '@react-pdf/renderer';
import downloadFooter from "./download_footer.PNG";
import download_ooredoo_logo from './download_ooredoo_logo.PNG';
import left_half_ooredoo from './left_half_ooredoo.PNG';
import right_half_ooredoo from './right_half_ooredoo.PNG';
import { getItemOfSessionStorage } from '../../services/common/utils';
import { SELECTED_LANG } from '../../services/common/Constants';



const styles = StyleSheet.create({
    page: {
      padding: 20,
      fontSize: 10,
    },
    header: {
      display: 'flex',
      flexDirection: 'row',
  
    },
    logo: {
      width: '250px',
    },
    table: {
      display: 'table',
      borderStyle: 'solid',
      borderRadius:'10px 10px 0px 0px',
      border:'1px solid',
      borderColor:'#59C0ED',
      padding: '0px 10px 0px 30px'
    },
    tableRow: {
      flexDirection: 'row',
      display: 'flex'
    },
    tableColHeader: {
      backgroundColor: '#ed1c24',
      color: '#FFFFFF',
      paddingVertical: 10,
      paddingHorizontal: 5,
      borderRight: '1px solid #fff',
      textAlign:'center',
      fontWeight:'bold'
    },
  
    tableColHeaderLast: {
        borderRight: '1px solid #ed1c24',
        borderTopRightRadius:'15px'
      },
  
      tableColHeaderFirst: {
        borderTopLeftRadius:'15px'
      },
    tableCol: {
      borderStyle: 'solid',
      padding: 5,
      borderRight: '1px solid #E0607E',
      borderBottom: '1px solid #E0607E',
      
    },
    tableColFirst:{
        borderLeft: '1px solid #E0607E',
    },
    
       tableCellHeader: {
      textAlign: 'center',
      fontWeight: 'bold',
      color: '#FFFFFF',
    },
    lastRowFirstCell:{
      borderBottomLeftRadius: '15px'
    },
    lastRowLastCell:{
    borderBottomRightRadius: '15px'
    },
    tableCell: {
      textAlign: 'center',
    },
  
    footer: {
      marginTop:'20px',
      display:'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      gap:'4px',
      marginLeft: '35px',
  
    },
    icon: {
      width: 20,
      marginHorizontal: 5,
    },
    text:{
      fontSize: '25px',
      fontWeight: 'bold',
      textTransform: 'uppercase',
      marginLeft:'5px',
      alignItems: 'center',
      textAlign: 'center',
      marginVertical: 'auto',
      fontWeight: 700
      //margin: '10px 0',
    },
    detailedOverview:{
      display: 'flex',
      flexDirection: 'row',
      paddingBottom: '20px'
  
      
    },
    leftIcon:{
        height: 60,
        width: 60,
        marginLeft:'-10px'
    }
  });
export function PDFDoc(){
   const linkedArray= {"apartynumber":"MSISDN","callstarttime":"CALL DATE","bpartynumber":"THIRD PARTY","downloadcalltype":"CALL TYPE","chargedamount":"AMOUNT","callduration":"DURATION","downloadservice":"SERVICE","downloadroaming":"ROAMING"}
    const data = [
        {
            "apartynumber": "96565046194",
            "callstarttime": "2024-04-29 11:51:30.0",
            "bpartynumber": "66638752",
            "downloadcalltype": "ORIGINATED ORIGINATED ORIGINATED ORIGINATED ORIGINATED ORIGINATED ORIGINATED",
            "chargedamount": "0",
            "callduration": "1 Units",
            "downloadservice": "SMSMO",
            "downloadroaming": "LocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocal"
        },
        {
            "apartynumber": "96565046194",
            "callstarttime": "2024-04-29 11:51:30.0",
            "bpartynumber": "66638752",
            "downloadcalltype": "ORIGINATED ORIGINATED ORIGINATED ORIGINATED ORIGINATED ORIGINATED ORIGINATED",
            "chargedamount": "0",
            "callduration": "1 Units",
            "downloadservice": "SMSMO",
            "downloadroaming": "LocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocal"
        },
        {
            "apartynumber": "96565046194",
            "callstarttime": "2024-04-29 11:51:30.0",
            "bpartynumber": "66638752",
            "downloadcalltype": "ORIGINATED ORIGINATED ORIGINATED ORIGINATED ORIGINATED ORIGINATED ORIGINATED",
            "chargedamount": "0",
            "callduration": "1 Units",
            "downloadservice": "SMSMO",
            "downloadroaming": "LocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocal"
        },
        {
            "apartynumber": "96565046194",
            "callstarttime": "2024-04-29 11:50:14.0",
            "bpartynumber": "66638752",
            "downloadcalltype": "ORIGINATED ORIGINATED ORIGINATED ORIGINATED ORIGINATED ORIGINATED ORIGINATED",
            "chargedamount": "0",
            "callduration": "0 Mins 19 Sec",
            "downloadservice": "VOICEMO",
            "downloadroaming": "LocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocal"
        },
        {
            "apartynumber": "96565046194",
            "callstarttime": "2024-04-29 11:50:14.0",
            "bpartynumber": "66638752",
            "downloadcalltype": "ORIGINATED ORIGINATED ORIGINATED ORIGINATED ORIGINATED ORIGINATED ORIGINATED",
            "chargedamount": "0",
            "callduration": "0 Mins 19 Sec",
            "downloadservice": "VOICEMO",
            "downloadroaming": "LocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocal"
        },
        {
            "apartynumber": "96565046194",
            "callstarttime": "2024-04-29 11:50:14.0",
            "bpartynumber": "66638752",
            "downloadcalltype": "ORIGINATED ORIGINATED ORIGINATED ORIGINATED ORIGINATED ORIGINATED ORIGINATED",
            "chargedamount": "0",
            "callduration": "0 Mins 19 Sec",
            "downloadservice": "VOICEMO",
            "downloadroaming": "LocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocal"
        },
        {
            "apartynumber": "96565046194",
            "callstarttime": "2024-04-28 14:07:18.0",
            "bpartynumber": "Internet Usage",
            "downloadcalltype": null,
            "chargedamount": "0",
            "callduration": "1.48 KB",
            "downloadservice": null,
            "downloadroaming": "LocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocal"
        },
        {
            "apartynumber": "96565046194",
            "callstarttime": "2024-04-28 14:07:16.0",
            "bpartynumber": "Internet Usage",
            "downloadcalltype": null,
            "chargedamount": "0",
            "callduration": "1.48 KB",
            "downloadservice": null,
            "downloadroaming": "LocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocal"
        },
        {
            "apartynumber": "96565046194",
            "callstarttime": "2024-04-28 14:06:18.0",
            "bpartynumber": "Internet Usage",
            "downloadcalltype": null,
            "chargedamount": "0",
            "callduration": "0 bytes",
            "downloadservice": null,
            "downloadroaming": "LocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocal"
        },
        {
            "apartynumber": "96565046194",
            "callstarttime": "2024-04-28 14:06:18.0",
            "bpartynumber": "Internet Usage",
            "downloadcalltype": null,
            "chargedamount": "0",
            "callduration": "0 bytes",
            "downloadservice": null,
            "downloadroaming": "LocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocal"
        },
        {
            "apartynumber": "96565046194",
            "callstarttime": "2024-04-28 14:06:16.0",
            "bpartynumber": "Internet Usage",
            "downloadcalltype": null,
            "chargedamount": "0",
            "callduration": "0 bytes",
            "downloadservice": null,
            "downloadroaming": "LocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocal"
        },
        {
            "apartynumber": "96565046194",
            "callstarttime": "2024-04-28 14:06:16.0",
            "bpartynumber": "Internet Usage",
            "downloadcalltype": null,
            "chargedamount": "0",
            "callduration": "0 bytes",
            "downloadservice": null,
            "downloadroaming": "LocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocal"
        },
        {
            "apartynumber": "96565046194",
            "callstarttime": "2024-04-28 14:05:02.0",
            "bpartynumber": "Internet Usage",
            "downloadcalltype": null,
            "chargedamount": "0",
            "callduration": "0 bytes",
            "downloadservice": null,
            "downloadroaming": "LocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocal"
        },
        {
            "apartynumber": "96565046194",
            "callstarttime": "2024-04-28 14:05:02.0",
            "bpartynumber": "Internet Usage",
            "downloadcalltype": null,
            "chargedamount": "0",
            "callduration": "0 bytes",
            "downloadservice": null,
            "downloadroaming": "LocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocal"
        },
        {
            "apartynumber": "96565046194",
            "callstarttime": "2024-04-28 14:05:01.0",
            "bpartynumber": "Internet Usage",
            "downloadcalltype": null,
            "chargedamount": "0",
            "callduration": "0 bytes",
            "downloadservice": null,
            "downloadroaming": "LocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocal"
        },
        {
            "apartynumber": "96565046194",
            "callstarttime": "2024-04-28 14:05:01.0",
            "bpartynumber": "Internet Usage",
            "downloadcalltype": null,
            "chargedamount": "0",
            "callduration": "0 bytes",
            "downloadservice": null,
            "downloadroaming": "LocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocal"
        },
        {
            "apartynumber": "96565046194",
            "callstarttime": "2024-04-28 14:04:52.0",
            "bpartynumber": "Internet Usage",
            "downloadcalltype": null,
            "chargedamount": "0",
            "callduration": "0 bytes",
            "downloadservice": null,
            "downloadroaming": "LocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocal"
        },
        {
            "apartynumber": "96565046194",
            "callstarttime": "2024-04-28 14:04:52.0",
            "bpartynumber": "Internet Usage",
            "downloadcalltype": null,
            "chargedamount": "0",
            "callduration": "0 bytes",
            "downloadservice": null,
            "downloadroaming": "LocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocal"
        },
        {
            "apartynumber": "96565046194",
            "callstarttime": "2024-04-28 14:04:45.0",
            "bpartynumber": "Internet Usage",
            "downloadcalltype": null,
            "chargedamount": "0",
            "callduration": "0 bytes",
            "downloadservice": null,
            "downloadroaming": "LocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocal"
        },
        {
            "apartynumber": "96565046194",
            "callstarttime": "2024-04-28 14:04:45.0",
            "bpartynumber": "Internet Usage",
            "downloadcalltype": null,
            "chargedamount": "0",
            "callduration": "0 bytes",
            "downloadservice": null,
            "downloadroaming": "LocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocal"
        },
        {
            "apartynumber": "96565046194",
            "callstarttime": "2024-04-28 14:02:14.0",
            "bpartynumber": "Internet Usage",
            "downloadcalltype": null,
            "chargedamount": "0",
            "callduration": "1.04 KB",
            "downloadservice": null,
            "downloadroaming": "LocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocal"
        },
        {
            "apartynumber": "96565046194",
            "callstarttime": "2024-04-28 14:02:09.0",
            "bpartynumber": "Internet Usage",
            "downloadcalltype": null,
            "chargedamount": "0",
            "callduration": "1.04 KB",
            "downloadservice": null,
            "downloadroaming": "LocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocal"
        },
        {
            "apartynumber": "96565046194",
            "callstarttime": "2024-04-28 13:33:13.0",
            "bpartynumber": "66638752",
            "downloadcalltype": "ORIGINATED ORIGINATED ORIGINATED ORIGINATED ORIGINATED ORIGINATED ORIGINATED",
            "chargedamount": "0",
            "callduration": "0 Mins 12 Sec",
            "downloadservice": "VOICEMO",
            "downloadroaming": "LocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocal"
        },
        {
            "apartynumber": "96565046194",
            "callstarttime": "2024-04-28 13:06:41.0",
            "bpartynumber": "66652767",
            "downloadcalltype": "ORIGINATED ORIGINATED ORIGINATED ORIGINATED ORIGINATED ORIGINATED ORIGINATED",
            "chargedamount": "0",
            "callduration": "1 Units",
            "downloadservice": "SMSMO",
            "downloadroaming": "LocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocal"
        },
        {
            "apartynumber": "96565046194",
            "callstarttime": "2024-04-28 13:00:31.0",
            "bpartynumber": "60490814",
            "downloadcalltype": "ORIGINATED ORIGINATED ORIGINATED ORIGINATED ORIGINATED ORIGINATED ORIGINATED",
            "chargedamount": "0",
            "callduration": "0 Mins 21 Sec",
            "downloadservice": "VOICEMO",
            "downloadroaming": "LocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocal"
        },
        {
            "apartynumber": "96565046194",
            "callstarttime": "2024-04-28 12:52:11.0",
            "bpartynumber": "Internet Usage",
            "downloadcalltype": null,
            "chargedamount": "0",
            "callduration": "1.48 KB",
            "downloadservice": null,
            "downloadroaming": "LocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocal"
        },
        {
            "apartynumber": "96565046194",
            "callstarttime": "2024-04-28 12:52:06.0",
            "bpartynumber": "Internet Usage",
            "downloadcalltype": null,
            "chargedamount": "0",
            "callduration": "1.48 KB",
            "downloadservice": null,
            "downloadroaming": "LocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocal"
        },
        {
            "apartynumber": "96565046194",
            "callstarttime": "2024-04-28 12:44:07.0",
            "bpartynumber": "Internet Usage",
            "downloadcalltype": null,
            "chargedamount": "0",
            "callduration": "1.36 KB",
            "downloadservice": null,
            "downloadroaming": "LocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocal"
        },
        {
            "apartynumber": "96565046194",
            "callstarttime": "2024-04-28 12:44:07.0",
            "bpartynumber": "Internet Usage",
            "downloadcalltype": null,
            "chargedamount": "0",
            "callduration": "1.36 KB",
            "downloadservice": null,
            "downloadroaming": "LocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocal"
        },
        {
            "apartynumber": "96565046194",
            "callstarttime": "2024-04-28 12:44:07.0",
            "bpartynumber": "Internet Usage",
            "downloadcalltype": null,
            "chargedamount": "0",
            "callduration": "1.36 KB",
            "downloadservice": null,
            "downloadroaming": "LocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocal"
        },
        {
            "apartynumber": "96565046194",
            "callstarttime": "2024-04-28 12:44:07.0",
            "bpartynumber": "Internet Usage",
            "downloadcalltype": null,
            "chargedamount": "0",
            "callduration": "1.36 KB",
            "downloadservice": null,
            "downloadroaming": "LocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocal"
        },
        {
            "apartynumber": "96565046194",
            "callstarttime": "2024-04-28 12:44:02.0",
            "bpartynumber": "Internet Usage",
            "downloadcalltype": null,
            "chargedamount": "0",
            "callduration": "1.36 KB",
            "downloadservice": null,
            "downloadroaming": "LocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocal"
        },
        {
            "apartynumber": "96565046194",
            "callstarttime": "2024-04-28 12:44:02.0",
            "bpartynumber": "Internet Usage",
            "downloadcalltype": null,
            "chargedamount": "0",
            "callduration": "1.36 KB",
            "downloadservice": null,
            "downloadroaming": "LocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocal"
        },
        {
            "apartynumber": "96565046194",
            "callstarttime": "2024-04-28 12:44:02.0",
            "bpartynumber": "Internet Usage",
            "downloadcalltype": null,
            "chargedamount": "0",
            "callduration": "1.36 KB",
            "downloadservice": null,
            "downloadroaming": "LocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocal"
        },
        {
            "apartynumber": "96565046194",
            "callstarttime": "2024-04-28 12:44:02.0",
            "bpartynumber": "Internet Usage",
            "downloadcalltype": null,
            "chargedamount": "0",
            "callduration": "1.36 KB",
            "downloadservice": null,
            "downloadroaming": "LocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocal"
        },
        {
            "apartynumber": "96565046194",
            "callstarttime": "2024-04-28 12:05:56.0",
            "bpartynumber": "Internet Usage",
            "downloadcalltype": null,
            "chargedamount": "0",
            "callduration": "1.48 KB",
            "downloadservice": null,
            "downloadroaming": "LocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocal"
        },
        {
            "apartynumber": "96565046194",
            "callstarttime": "2024-04-28 12:05:56.0",
            "bpartynumber": "Internet Usage",
            "downloadcalltype": null,
            "chargedamount": "0",
            "callduration": "1.48 KB",
            "downloadservice": null,
            "downloadroaming": "LocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocal"
        },
        {
            "apartynumber": "96565046194",
            "callstarttime": "2024-04-28 11:45:55.0",
            "bpartynumber": "Internet Usage",
            "downloadcalltype": null,
            "chargedamount": "0",
            "callduration": "1.48 KB",
            "downloadservice": null,
            "downloadroaming": "LocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocal"
        },
        {
            "apartynumber": "96565046194",
            "callstarttime": "2024-04-28 11:45:55.0",
            "bpartynumber": "Internet Usage",
            "downloadcalltype": null,
            "chargedamount": "0",
            "callduration": "1.48 KB",
            "downloadservice": null,
            "downloadroaming": "LocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocalLocal"
        }
    ]
    const widths = ['12%', '15%','12%','15%','10%','10%','13%','13%']


    const rowsData = data?.map(row => Object.values(row)) 
    const maxLen_Rows = rowsData?.map(row => row.reduce((len,cur)=>{
        return(Math.max(len, cur ? Math.ceil(cur.toString()?.length/10) : 0))}, 0) 
    )
    
    const chunks = [];
    let currentChunk = [];
    let currentSum = 0;
    let firstRow = 40;
    let maxSum = 60;
    maxLen_Rows.forEach((item, index) => {
      if (currentSum + item > (chunks?.length === 0 ?firstRow : maxSum)) {
        chunks.push(currentChunk);
        currentChunk = [item];
        currentSum = item;
        if(index === maxLen_Rows?.length -1 ){ chunks.push(currentChunk) } 
      } else {
        currentChunk.push(item);
        currentSum += item;
        if(index === maxLen_Rows?.length -1 ){ chunks.push(currentChunk) } 
      }
    });
    const requiredChunks = chunks.map((item)=> item?.length)
    let finalSumChunks=[];
    let sum = 0;
    requiredChunks.reduce((prev, cur)=> {sum = sum+ cur; finalSumChunks.push(sum) ;return sum }, 0)

    console.log("required chunks",  requiredChunks, requiredChunks.reduce((prev, cur)=> prev+cur, 0),finalSumChunks );
    const DataSlices = [];
    let sum2 = 0;
    finalSumChunks.reduce((prev, cur) => { sum2+=cur; DataSlices.push(data?.slice(prev, cur)); return cur}, 0)
    console.log("DataSlices", DataSlices);
    // const resultData = []
    // const result = chunks.reduce((prev, cur) => { 
    //         console.log( prev, cur);
    //         resultData.push(data.slice(prev, cur+1));
    //         return prev+1
    //     }, 0)

// console.log(resultData)

    const PDFDocument = ()=>{
        
  const language = getItemOfSessionStorage(SELECTED_LANG);
        return(
 
<Document>


            
{DataSlices?.map((pageRows, pageIndex)=>(
  <Page size="A4" style={styles.page}>
  {pageIndex === 0 &&<View>
    <View style={[styles.header, {justifyContent: language === 'ar' ? '':'flex-end'}]}>
    <Image style={styles.logo} 
      src={download_ooredoo_logo}></Image>
    </View>
    <View style={styles.detailedOverview}>
      <Image style={styles.leftIcon} 
      src={left_half_ooredoo}></Image>
      <Text style={styles.text}>DETAILED OVERVIEW</Text> 
      
      </View>
    </View>}
    
    <View style={styles.table}>
      <View style={styles.tableRow}>
        {Object.values(linkedArray)?.map((header, index) => (
          <View style={[
            styles.tableColHeader, 
            (Object.keys(linkedArray).length -1) === index ? styles.tableColHeaderLast:null, 
            index === 0 ? styles.tableColHeaderFirst:null,
            {width: widths[index]} 
           ]} key={index}>
            <Text>{header}</Text>
          </View>
        ))}
      </View>
      {pageRows.map((row, rowIndex) => (
        <React.Fragment key={rowIndex}>
            <View style={styles.tableRow} key={rowIndex}>
              {Object.keys(linkedArray)?.map((obj, index)=> (
              <View style={[
                styles.tableCol, 
                index===0?styles.tableColFirst:null, 
                {width: widths[index]}, 
                pageRows?.length -1 === rowIndex && index === 0 ? styles.lastRowFirstCell: null,
                pageRows?.length -1 === rowIndex && index === Object.keys(linkedArray)?.length -1 ? styles.lastRowLastCell: null,
              ]}>
                <Text style={styles.tableCell}>{row?.[obj]?.match(/.{1,10}/g).join('\n') }</Text>
              </View>))}
           
            </View>
        </React.Fragment>
      ))}
    </View>
    {pageIndex === DataSlices?.length -1 && (
      <Image style={styles.footer} src ={downloadFooter}/>
    )}
  </Page>
))}
</Document>)
    }
    const handleGeneratePDF = async () => {
        
        const blob = await pdf(<PDFDocument />).toBlob();
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'call_details.pdf';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      };
    return(

        <>
        <button onClick={handleGeneratePDF} style={{ marginBottom: '20px' }}>
        Click here kannaiah
        </button>

        

        </>

)}